import React from 'react';

const Home_Front = () => {
  return (
    <div className="container d-flex justify-content-center align-items-center mt-3" >
      <div className="text-center">
        <h1>Future Destination</h1>
      </div>
    </div>
  );
};

export default Home_Front;
